module.exports = __webpack_public_path__ + "img/wing-left-new.5b4f1197.svg";